import { Box } from '@mui/material';

import { FHSkeletonLoader } from '../../base';
import { FORTA_WHITE } from '../../../utils/colors';

interface CardSkeletonLoaderProps {
  tpLoader?: boolean;
  supervisionLoader?: boolean;
}

function CardSkeletonLoader({ tpLoader, supervisionLoader }: CardSkeletonLoaderProps) {
  return (
    <Box
      sx={{
        p: 2,
        borderRadius: 2,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        minWidth: 230,
        minHeight: tpLoader ? 142 : 175,
        width: '100%',
        backgroundColor: FORTA_WHITE,
      }}
    >
      {/* Header */}
      <Box display="flex" alignItems="center" gap={1.5} mb={2.5}>
        <FHSkeletonLoader variant="circular" height={30} width={30} />
        <FHSkeletonLoader containerStyles={{ width: '150px' }} />
      </Box>

      {/* Content */}
      <Box sx={{ flex: tpLoader ? 0 : 1 }}>
        <FHSkeletonLoader containerStyles={{ width: '60%', mb: 2.5 }} />
        {!tpLoader && <FHSkeletonLoader containerStyles={{ width: '80%' }} />}
      </Box>

      {/* Footer */}
      <Box display="flex" justifyContent="space-between">
        <FHSkeletonLoader width={100} sx={{ borderRadius: '24px' }} />
        {!supervisionLoader && <FHSkeletonLoader width={50} sx={{ borderRadius: '24px' }} />}
      </Box>
    </Box>
  );
}

export default CardSkeletonLoader;
